export const COLLABORATION_CLEAR_STORE = 'COLLABORATION_CLEAR_STORE';
export const COLLABORATION_UPDATE_USERS = 'COLLABORATION_UPDATE_USERS';
export const COLLABORATION_INITIAL_LOAD = 'COLLABORATION_INITIAL_LOAD';
export const COLLABORATION_UPDATE_CHANNEL = 'COLLABORATION_UPDATE_CHANNEL';
export const COLLABORATION_SET_MENTION_ID = 'COLLABORATION_SET_MENTION_ID';
export const COLLABORATION_SWITCH_CHANNEL = 'COLLABORATION_SWITCH_CHANNEL';
export const COLLABORATION_SET_ACTIVE_TAG = 'COLLABORATION_SET_ACTIVE_TAG';
export const COLLABORATION_SCROLL_TO_BOTTOM = 'COLLABORATION_SCROLL_TO_BOTTOM';
export const COLLABORATION_HAS_NEW_MESSAGES = 'COLLABORATION_HAS_NEW_MESSAGES';
export const COLLABORATION_SET_GLOBAL_LOADER = 'COLLABORATION_SET_GLOBAL_LOADER';
export const COLLABORATION_CLEAR_NEW_MESSAGES = 'COLLABORATION_CLEAR_NEW_MESSAGES';
export const COLLABORATION_SET_PREPARED_CANVAS = 'COLLABORATION_SET_PREPARED_CANVAS';
export const COLLABORATION_SET_REPLY_MESSAGE_ID = 'COLLABORATION_SET_REPLY_MESSAGE_ID';
export const COLLABORATION_SET_MESSAGES_IN_STORE = 'COLLABORATION_SET_MESSAGES_IN_STORE';
export const COLLABORATION_SET_HIGHLIGHT_MESSAGE = 'COLLABORATION_SET_HIGHLIGHT_MESSAGE';
export const COLLABORATION_SET_HAS_MORE_MESSAGES = 'COLLABORATION_SET_HAS_MORE_MESSAGES';
export const COLLABORATION_SET_MESSAGE_DECORATOR = 'COLLABORATION_SET_MESSAGE_DECORATOR';
export const COLLABORATION_UPDATE_DIRECT_CHANNELS = 'COLLABORATION_UPDATE_DIRECT_CHANNELS';
